export var button_textTransform = {
    textTransform: "capitalize",
};
export var panelTitlesVariant = "h6";
